export const DallasData = [
  {
    title: "Legal translation services",
    detail:
      "Legal translations require documents such as affidavits, contracts, agreements, and other types of legal documents. It's a good thing our legal translators know civic law, corporate law, environmental law, and more. Their expertise in language plus their experience in legal industries make them a great fit for your legal translation needs.",
    link: "/legal-translation.php",
  },
  {
    title: "Medical translation  services ",
    detail:
      "In the medical field, you may be dealing with documents such as patient records, lab reports, physician notes, and more: and all this needs to be translated. What better way to translate these documents than with the help of our medical translators? On the other hand, our medical interpreters can assist with all patient interactions, making it easier to communicate.        ",
    link: "/medical-translation.php",
  },
  {
    title: "Financial translation services",
    detail:
      "Financial translations require the accuracy and expertise that Tomedes translation services bring to every translation project. From traditional finance to the newest types of financial services, such as eCommerce and cryptocurrency, translations for financial firms have never been easier. Our financial translators can turn any document into over 120 languages.",
    link: "/financial-translation.php",
  },
  {
    title: "Technical translation services ",
    detail:
      "The scientific, technological, and other technical fields have specific terminologies that only a technical translator can turn into another language. Tomedes' technical translators have the linguistic knowledge that can turn your technical reports into successfully translated documents, especially equipped with the know-how of your industries.",
    link: "/technical-translation.php",
  },
];

export const LanguagesInDallas = [
  {
    heading: "Spanish",
    detail:
      "Spanish translation services are available for Dallas residents, which ensures that non-English speaking communities have services available for them. Meanwhile, for your business needs, the Spanish language is a major language of the world that could help you broaden your horizons.",
    link: "/spanish-translation.php",
  },
  {
    heading: "Chinese",
    detail:
      "For business, Chinese translation services are important in disseminating information. Whether it's Chinese to English or English to Chinese that you need, as well as any other language paired with Chinese, there's tons to choose from. You can't go wrong with a Chinese translator from Tomedes in Dallas for your translations.",
    link: "/mandarin-chinese-translation",
  },
  {
    heading: "Korean",
    detail:
      "Korean is gaining popularity in the modern global culture, with Korean translation services proving important for business as well. Dallas, Texas has a population of 41,000 Korean speakers: why not access this demographic through language services and translation services? Whether you need Korean for medical, legal, or any other industry, we're here to help",
    link: "/korean-translation.php",
  },
  {
    heading: "Arabic",
    detail:
      "A popular language for Dallas, TX, and for translation services, Arabic has a non-Latin alphabet and is composed of a unique script. Don't trust just anyone to translate English to Arabic or Arabic to English or any other language, trust Tomedes. Dallas has a population of 55,304 Arabic speakers. Bridge the language barrier with Tomedes.",
    link: "/arabic-translation.php",
  },
  {
    heading: "Vietnamese",
    detail:
      "Another popular language in Dallas, Vietnamese certified translation services in Dallas, TX from Tomedes can help businesses to grow their business, as well as individuals for applications and communications. Vietnamese is spoken by 72,000 residents of Dallas--don't let them down, and use translation services.",
    link: "/vietnamese-translation.php",
  },
  {
    heading: "Farsi",
    detail:
      "Dallas residents are a diverse group of people, which includes the Farsi-speaking community. Farsi is spoken by an estimated 110 million people worldwide. That means your business could potentially reach this language demographic with Farsi translation services. Don't limit your potential and reach to Tomedes today.",
    link: "#",
  },
];
